export default __webpack_public_path__ + "static/media/logo-light.a75c26c7.svg";